import React from "react";
import PropTypes from "prop-types";
import styles from "./Header.module.css";
import logo from "../../../assets/logo-light.png";

function Header({ height = "120px", className = "", showShadow = true }) {
  const headerClasses = [
    styles.header,
    showShadow ? styles.withShadow : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      // Announce to screen readers
      const announcement = document.createElement("div");
      announcement.setAttribute("aria-live", "polite");
      announcement.setAttribute("aria-atomic", "true");
      announcement.textContent = "Scrolled to contact section";
      announcement.style.position = "absolute";
      announcement.style.left = "-10000px";
      document.body.appendChild(announcement);
      setTimeout(() => announcement.remove(), 1000);
    }
  };

  return (
    <>
      {/* Mobile top bar - only visible on mobile */}
      <div className={styles.mobileTopBar}>
        <div className={styles.mobileTopBarContent}>
          {/* Logo */}
          <div className={styles.logoContainer} aria-label="ENGIE logo">
            <img
              src={logo}
              alt="ENGIE - Leading energy company logo"
              className={styles.logo}
            />
          </div>

          {/* Contact Button */}
          <button
            className={styles.contactButton}
            onClick={scrollToContact}
            type="button"
            aria-label="Scroll to contact information section"
            aria-describedby="contact-button-help"
          >
            CONTACT US
          </button>
        </div>
      </div>

      {/* Main header with background image */}
      <header
        className={headerClasses}
        style={{ "--header-height": height }}
        role="banner"
        aria-label="ENGIE website header"
      >
        <div className={styles.headerContent}>
          {/* Logo - hidden on mobile */}
          <div className={styles.logoContainer} aria-label="ENGIE company logo">
            <img
              src={logo}
              alt="ENGIE - Leading energy company logo"
              className={styles.logo}
            />
          </div>

          {/* Contact Button - hidden on mobile */}
          <button
            className={styles.contactButton}
            onClick={scrollToContact}
            type="button"
            aria-label="Scroll to contact information section"
            aria-describedby="contact-button-help"
          >
            CONTACT US
          </button>
          <div id="contact-button-help" className="sr-only">
            Click to scroll to the contact information section at the bottom of
            the page
          </div>
        </div>
      </header>
    </>
  );
}

Header.propTypes = {
  height: PropTypes.string,
  className: PropTypes.string,
  showShadow: PropTypes.bool,
};

export default Header;
